/* eslint-disable @typescript-eslint/no-unused-vars */
import type {
    ReviewPacketData,
    ReviewPacketVerticesData,
} from '../SolicitorDocumentPage';
import { matchingClassDecorator } from './decorator/matching';
import {
    matchingShowSelected,
    matchingShowStep,
} from './introspector/equality';
import { inner } from './introspector/operator';
import { directVertices, validVertices } from './introspector/system';
import { VerticeSystem } from './abstract';

@matchingClassDecorator
export class Vertices
    extends VerticeSystem
    implements Pick<ReviewPacketVerticesData, 'percentageMatch'>
{
    type: 'show' | 'sign-check' | 'match' | 'compare' | '' = '';

    protected object: ReviewPacketData | null = null;

    set current_object(t: ReviewPacketData | null) {
        this.object = t;
    }

    get current_object(): ReviewPacketData | null {
        return this.object;
    }

    @validVertices
    @directVertices
    set matching(value: VerticeSystem) {
        this.object = null;
        this.percentageMatchThreeshold = value.Threeshold;
        Object.setPrototypeOf(value, VerticeSystem.prototype);
        Object.seal(value);
    }

    percentageMatchThreeshold: number | undefined;

    percentageMatch?: string | undefined;

    // eslint-disable-next-line no-underscore-dangle, @typescript-eslint/explicit-function-return-type
    @matchingShowSelected
    @matchingShowStep
    _knownInstance(self: Vertices): boolean {
        const system: VerticeSystem = self;
        return (
            (system.showSelectedSteps === true && system.showStep === false) !==
            true
        );
    }
}
